import { handleAuthResponse } from '../auth';

// Get calendar events from backend
export const getCalendarEvents = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/calendar/events`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json"
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// Update a calendar event
export const updateCalendarEvent = (eventId, updates) => {
    return fetch(`${process.env.REACT_APP_API_URL}/calendar/event`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ eventId, updates })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

//Get all events
export const getAllEvents = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/allevents`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getAllUsersTodate = (token) => {

    return fetch(`${process.env.REACT_APP_API_URL}/users`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getAllRegistrations = () => {
   
    return fetch(`${process.env.REACT_APP_API_URL}/eventregistrations`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
           
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


export const getPresentationById =(presentationId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentationsbyId/${presentationId}`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


export const getPresentationsByEvent =(eventId, sortfield, sortDirection, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentationsbyEvent/${eventId}/?sortfield=${sortfield}&sortdirection=${sortDirection}`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getEventById = (eventId, token) => {

    return fetch(`${process.env.REACT_APP_API_URL}/eventdetailsbyId/${eventId}`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const getEventsForGroup = (groupId, token) => {

    return fetch(`${process.env.REACT_APP_API_URL}/events/eventsbygroup/${groupId}`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const addEventForGroup = (groupId, token, formData) => {
    return fetch(`${process.env.REACT_APP_API_URL}/event/create/${groupId}`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: formData
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const createDownloadLink = (token, fileInfo) => {

    return fetch(`${process.env.REACT_APP_API_URL}/file/downloadfile`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(fileInfo)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const creatNewProposalSubmission = async (token, proposalInfo) =>{
   
    return await fetch(`${process.env.REACT_APP_API_URL}/createProposalPresentation`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },        
        body: JSON.stringify({ proposalInfo })
        
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// Public: submit a "Call for Presentations" entry for the 2027 conference.
// Saved server-side to the presentations_27 collection.
export const submitPresentation2027 = (submission) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentation27/create`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(submission)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// Signed-in: list all 2027 Call for Presentations submissions (newest first).
export const getPresentations2027 = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentations27`, {
        method: "GET",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// Accept (claim) a 2027 presentation on behalf of a committee. Fails if it's
// already accepted by another committee.
export const acceptPresentation2027 = (presentationId, committee, acceptedByUserName) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentation27/${presentationId}/accept`, {
        method: "PUT",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ committee, acceptedByUserName })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// Release (un-accept) a 2027 presentation so other committees can claim it.
// Only the committee that currently holds it may release it.
export const releasePresentation2027 = (presentationId, committee) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentation27/${presentationId}/release`, {
        method: "PUT",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ committee })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// Set (or clear, with null) the scheduled date/time for a 2027 presentation.
export const schedulePresentation2027 = (presentationId, scheduledAt) => {
    return fetch(`${process.env.REACT_APP_API_URL}/presentation27/${presentationId}/schedule`, {
        method: "PUT",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ scheduledAt })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// Locked-down create endpoint used by the public Past Events page. Server
// rejects everyone except the single operator user ID.
export const createPastEvent = (eventInfo, newEventId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/pastevent/create`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ eventInfo, newEventId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// Locked-down presentation upload for the public Past Events showcase page.
// Server rejects everyone except the single operator user ID. Pass a FormData
// with optional `video` file plus text fields (title, description, etc.).
export const createPastEventPresentation = (formData) => {
    return fetch(`${process.env.REACT_APP_API_URL}/pastevent/presentation/create`, {
        method: "POST",
        credentials: 'include',
        body: formData
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

// Public listing of events created via createPastEvent. Used by /past-events
// to merge dynamic admin-created events into the year accordions.
export const listPastEvents = () => {
    return fetch(`${process.env.REACT_APP_API_URL}/pastevents/list`, {
        method: "GET"
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const createNewEvent = (token, groupId, userId, newEventId, eventInfo) => {
    // /file/create/:userId
    return fetch(`${process.env.REACT_APP_API_URL}/event/create/${userId}`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ eventInfo, groupId, userId, newEventId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const updateEvent = (groupId, userId, event) => {

    return fetch(`${process.env.REACT_APP_API_URL}/event/update`, {
        method: "PUT",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ event, userId, groupId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const removeEvent = (token, eventId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/event/delete`, {
        method: "DELETE",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ eventId })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const registerUser = async (body, eventId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/eventregistration/${eventId}`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



export const registerSponsor = (body, eventId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/eventsponsor/${eventId}`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


export const submitSurvey = (body, eventId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/submitsurvey/${eventId}`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
}


export const createSchedule = (body) => {
    return fetch(`${process.env.REACT_APP_API_URL}/eventschedule`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
}


//Get all events
export const getSchedule = (eventName, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/getschedule`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ eventName: eventName })
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


export const updateSchedule = (body) => {

    return fetch(`${process.env.REACT_APP_API_URL}/updateschedule`, {
        method: "PUT",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


//Payment Checkout
export const checkOut = (body) => {
    return fetch(`${process.env.REACT_APP_API_URL}/checkoutpay`, {
        method: "POST",
        credentials: 'include',
        mode: 'cors',
        headers: {
            Accept: "application/json",
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};